import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
    UPDATE_PAYMENT_METHOD,
    GENERATE_PAYMENT_LINK_FAILED,
    GENERATE_PAYMENT_LINK_SUCCESS,
    GENERATE_PAYMENT_LINK_START
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { get, update, push } from "firebase/database";
import base64 from 'react-native-base64';
import AccessKey from '../other/AccessKey';
import i18n from "i18n-js";
import { sendWithdrawalNotification } from '../utils/discordNotifications';
import { postWithIdToken, makeMileRequestId } from './mileactions';
import { getSettingsOnce } from '../other/settingsOnce';

export const fetchPaymentMethods = () => async (dispatch) => {

    const {
      config,
      paymentSettingsRef
    } = firebase;

    dispatch({
      type: FETCH_PAYMENT_METHODS,
      payload: null
    });

    const usertype = store.getState().auth.profile.usertype;

    if(usertype == 'admin'){
        try {
            const snapshot = await get(paymentSettingsRef);
            const data = snapshot.val();
            if(data){
              dispatch({
                type: FETCH_PAYMENT_METHODS_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_provider_found,
              });
            }
        } catch (error) {
            dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: error.message,
            });
        }
    } else {
        const settings = store.getState().settingsdata.settings;
        let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
        let url = `${host}/get_providers`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.length > 0) {
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_SUCCESS,
                        payload: responseJson,
                    });
                }else{
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_FAILED,
                        payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
                });
            });
    }
  };

  export const fetchPaymentMethodsPromise = () => async (dispatch) => {
      const {
        config,
        paymentSettingsRef
      } = firebase;
      dispatch({
        type: FETCH_PAYMENT_METHODS,
        payload: null
      });
      const usertype = store.getState().auth.profile.usertype;
      if(usertype == 'admin'){
        try {
          const snapshot = await get(paymentSettingsRef);
          const data = snapshot.val();
          if(data){
            dispatch({
              type: FETCH_PAYMENT_METHODS_SUCCESS,
              payload: data
            });
            return data;
          } else {
            dispatch({
              type: FETCH_PAYMENT_METHODS_FAILED,
              payload: store.getState().languagedata.defaultLanguage.no_provider_found,
            });
            throw new Error('No provider found');
          }
        } catch (error) {
          dispatch({
            type: FETCH_PAYMENT_METHODS_FAILED,
            payload: error.message,
          });
          throw error;
        }
      } else {
        const settings = store.getState().settingsdata.settings;
        let host = typeof window !== 'undefined' && window.location && settings.CompanyWebsite === window.location.origin ? window.location.origin : `https://${config.projectId}.web.app`;
        let url = `${host}/get_providers`;
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          const responseJson = await response.json();
          if (responseJson.length > 0) {
            dispatch({
              type: FETCH_PAYMENT_METHODS_SUCCESS,
              payload: responseJson,
            });
            return responseJson;
          } else {
            dispatch({
              type: FETCH_PAYMENT_METHODS_FAILED,
              payload: store.getState().languagedata.defaultLanguage.no_provider_found,
            });
            throw new Error('No provider found');
          }
        } catch (error) {
          dispatch({
            type: FETCH_PAYMENT_METHODS_FAILED,
            payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
          });
          throw error;
        }
      }
  };

  export const editPaymentMethods = (data) => (dispatch) => {
    const {
        paymentSettingsRef
    } = firebase;
    dispatch({
      type: UPDATE_PAYMENT_METHOD,
      payload: data 
    });
    update(paymentSettingsRef, data);
  }
  


export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
        status: null
    });
};


export const addToWallet = (uid, amount, operatorUid, remark = '') => async (dispatch) => {
    const {
        walletHistoryRef,
        singleUserRef
    } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    // Web-only action (FinanceAdminControls bulk loops, AddMoney): the store /
    // 60 s-cached settings instead of one /settings read per credited driver.
    const settings = await getSettingsOnce();

    // Use get() instead of onValue() to fetch data once
    const snapshot = await get(singleUserRef(uid));
    
    if (snapshot.val()) {
        const userData = snapshot.val();
        let walletBalance = parseFloat(userData.walletBalance) || 0;
        let topUpBalance = parseFloat(userData.topUpBalance) || 0;
        const pushToken = userData.pushToken;
        const usertype = userData.usertype;
        
        // For drivers, only update topUpBalance
        // For other users, update walletBalance
        if (usertype === 'driver') {
            topUpBalance = parseFloat((topUpBalance + parseFloat(amount)).toFixed(settings.decimal));
            // Don't update walletBalance for drivers when adding money
        } else {
            // For customers and other users, update walletBalance
            walletBalance = parseFloat((walletBalance + parseFloat(amount)).toFixed(settings.decimal));
        }
        
        // Create transaction reference with operator UID and remark
        const txRef = `${operatorUid}${remark ? '-' + remark : ''}`;
        
        let details = {
            type: 'Credit',
            amount: parseFloat(amount),
            date: new Date().getTime(),
            txRef: txRef,
            operatorUid: operatorUid,
            remark: remark
        }
        
        // Update based on user type
        const updateData = usertype === 'driver' 
            ? { topUpBalance: topUpBalance }
            : { walletBalance: walletBalance };
            
        update(singleUserRef(uid), updateData).then(() => {
                push(walletHistoryRef(uid), details).then(()=>{
                    dispatch({
                        type: UPDATE_WALLET_BALANCE_SUCCESS,
                        payload: null
                    });
                }).catch(error=>{
                    dispatch({
                        type: UPDATE_WALLET_BALANCE_FAILED,
                        payload: error.code + ": " + error.message,
                    });            
                })
                if(pushToken){
                    RequestPushMsg(
                        pushToken,
                        {
                            title: store.getState().languagedata.defaultLanguage.notification_title,
                            msg:  store.getState().languagedata.defaultLanguage.wallet_updated,
                            screen: 'Wallet'
                        }
                    );
                }
        }).catch(error=>{
            dispatch({
                type: UPDATE_WALLET_BALANCE_FAILED,
                payload: error.code + ": " + error.message,
            });
        });
    } else {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: "User not found",
        });
    }
};

// Server-side since the Donkey Mile redemption release: the old client-side
// get()+update() here could blind-overwrite the transactional debits of the
// airtime/donation Cloud Functions (double-spending the same miles) and
// wrote donkeyMiles back as a string. The redeem_miles_wallet CF does the
// debit + wallet credit transactionally, writes both histories, and sends
// the push. The uid parameter is kept for caller compatibility but the
// server derives the user from the Bearer token.
export const redeemMilesForWallet = (uid, milesToRedeem) => async (dispatch) => {
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const miles = parseFloat(milesToRedeem);
        if (!(miles > 0)) {
            throw new Error('Invalid amount');
        }
        await postWithIdToken('/redeem_miles_wallet', {
            miles,
            requestId: makeMileRequestId(),
        });

        dispatch({
            type: UPDATE_WALLET_BALANCE_SUCCESS,
            payload: null,
            status: 'success'
        });

    } catch (error) {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: error.code === 'insufficient_miles' ? 'Insufficient Donkey Miles' : (error.message || 'Redemption failed'),
            status: 'failed'
        });
    }
};

export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    const withdrawData = {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        processed:false,
        mobile: profile.mobile || ''
    };

    push(withdrawRef, withdrawData);
    
    // Send Discord notification for new withdrawal request
    try {
        const settings = store.getState()?.settingsdata?.settings || {};
        await sendWithdrawalNotification(withdrawData, settings);
    } catch (error) {
        console.error('Failed to send Discord withdrawal notification:', error);
    }
       
};

export const withdrawBalanceViaTransfer = (profile, transferData) => async (dispatch) => {

    const {
        withdrawRef,
        config
    } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });
    
    // Add mobile to transferData if not present
    const withdrawDataWithMobile = {
        ...transferData,
        mobile: transferData.mobile || profile.mobile || ''
    };
    
    push(withdrawRef, withdrawDataWithMobile);

    // Send Discord notification for new withdrawal request
    try {
        const settings = store.getState()?.settingsdata?.settings || {};
        await sendWithdrawalNotification(withdrawDataWithMobile, settings);
    } catch (error) {
        console.error('Failed to send Discord withdrawal notification:', error);
    }

    // Send SMS for trip cancellation
    const settings = store.getState().settingsdata.settings;
    const host = (typeof window !== 'undefined' && window.location && settings.CompanyWebsite === window.location.origin)
        ? window.location.origin
        : `https://${config.projectId}.web.app`;

    const url = `${host}/send_withdraw_success_sms`;

    try {
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + base64.encode(config.projectId + ':' + AccessKey)
            },
            body: JSON.stringify({
                customer_contact: profile.mobile,
                amount: transferData.amount,
                bankAccount: transferData.bankAccount,
                accountName: transferData.name,
                reference:  transferData.reference || transferData.tx_ref,
            })
        });
    } catch (err) {
        console.log('[WithdrawSMS] Error sending SMS:', err.message);
    }
};

export const sendPaymentLinkSMSMessage = async ({ order_id, amount, driver_name, driver_contact, customer_contact, reference, short_url }) => {
    const { config } = firebase;
    const settings = store.getState().settingsdata.settings;
    try {
        const smsPayload = {
            order_id,
            amount,
            driver_name,
            driver_contact,
            customer_contact,
            reference,
            short_url
        };

        const host = (typeof window !== 'undefined' && window.location && settings.CompanyWebsite === window.location.origin)
            ? window.location.origin
            : `https://${config.projectId}.web.app`;

        const url = `${host}/send_payment_link_sms`;

        const smsResponse = await fetch(url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + base64.encode(config.projectId + ':' + AccessKey)
                },
                body: JSON.stringify(smsPayload)
            }
        );

        const smsJson = await smsResponse.json();
        console.log('SMS sent response:', smsJson);
        return smsJson;
    } catch (error) {
        console.error('Failed to send SMS:', error);
        return { success: false, error: error.message };
    }
};

export const generatePaymentLinkAndSendSMS = (booking) => {
    const { auth, config } = firebase;
    const settings = store.getState().settingsdata.settings;

    const host = (typeof window !== 'undefined' && window.location && settings.CompanyWebsite === window.location.origin)
        ? window.location.origin
        : `https://${config.projectId}.web.app`;

    const url = `${host}/generate_payment_link`;
    return async (dispatch, getState) => {
        const { t } = i18n;
        dispatch({ type: GENERATE_PAYMENT_LINK_START });

        const user = auth?.currentUser;
        if (!user) {
            dispatch({ type: GENERATE_PAYMENT_LINK_FAILED, payload: t('user_not_logged_in') });
            return;
        }

        if (!booking || !booking.customer_contact || !booking.trip_cost || !booking.id) {
            dispatch({ type: GENERATE_PAYMENT_LINK_FAILED, payload: t('invalid_booking_data') });
            return;
        }

        const payload = {
            order_id: booking.id,
            amount: parseFloat(booking.trip_cost).toFixed(settings.decimal),
            currency: settings.code,
            mobile_no: booking.customer_contact
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + base64.encode(config.projectId + ':' + AccessKey),
                },
                body: JSON.stringify(payload),
            });

            const json = await response.json();
            console.log('Payment link response:', json);
            if (json.status && json.short_url) {
                await sendPaymentLinkSMSMessage({
                    order_id: booking.id,
                    amount: booking.trip_cost,
                    driver_name:  booking.driver_name,
                    driver_contact: booking.driver_contact,
                    customer_contact: booking.customer_contact,
                    reference: booking.reference,
                    short_url: json.short_url
                });
                dispatch({ type: GENERATE_PAYMENT_LINK_SUCCESS, payload: json });
            } else {
                dispatch({ type: GENERATE_PAYMENT_LINK_FAILED, payload: json.message || t('payment_link_failed') });
            }
        } catch (error) {
            dispatch({ type: GENERATE_PAYMENT_LINK_FAILED, payload: error.message || t('unexpected_error') });
        }
    };
};

// Wallet > Transfer to top-up runs on the server (transfer_wallet_to_topup):
// ONE server transaction moves the driver's earnings (walletBalance) into the
// commission float (topUpBalance) and writes both history rows. The app no
// longer writes either balance or walletHistory.
// requestId: the screen mints ONE per transfer intent (makeMileRequestId())
// and sends the same one again when the answer says `retryable`, so a retry
// after a lost answer replays instead of transferring twice. `uid` is kept for
// caller compatibility; the server takes the account from the ID token.
// Resolves { success, retryable, code, error, walletBalance?, topUpBalance? }:
// `error` is display-ready (live strings), `code` is the server's code
// (insufficient_balance, invalid_amount, not_driver, in_progress,
// request_id_reused, auth_required, auth_invalid, session_revoked,
// not_signed_in, server_error, ...; null = no answer).
export const transferWalletToTopup = (uid, amount, requestId) => async (dispatch) => {
    const { t } = i18n;
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });
    try {
        const res = await postWithIdToken('/transfer_wallet_to_topup', {
            amount: parseFloat(amount),
            requestId: requestId || makeMileRequestId()
        });
        if (!res || res.success !== true) {
            // Not the endpoint's answer (an HTML page or an older server
            // answering 200): the outcome is unknown, see `retryable` below.
            const unknown = new Error((res && res.error) || 'Unexpected answer');
            unknown.code = (res && res.code) || null;
            unknown.payload = res || {};
            throw unknown;
        }
        dispatch({
            type: UPDATE_WALLET_BALANCE_SUCCESS,
            payload: null,
            status: 'success'
        });
        return {
            success: true,
            retryable: false,
            code: null,
            error: null,
            replayed: res.replayed === true,
            walletBalance: res.walletBalance,
            topUpBalance: res.topUpBalance
        };
    } catch (error) {
        const code = (error && error.code) || null;
        const signInAgain = code === 'auth_required' || code === 'auth_invalid' || code === 'session_revoked' || code === 'not_signed_in';
        const msg = code === 'insufficient_balance' ? t('transfer_more_than_earning')
            : code === 'invalid_amount' ? t('transfer_below_zero')
            : signInAgain ? t('sign_in_again', { defaultValue: 'Your session has expired. Please sign in again.' })
            : t('transfer_failed');
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: msg,
            status: 'failed'
        });
        // retryable = keep the same requestId for the next attempt, because
        // the money may have moved: no answer (network), an answer without a
        // code (a proxy or crash page, not the endpoint's own refusal), the
        // endpoint's server_error (it can fail after the debit), or this very
        // request still being processed. A retry then replays the real
        // outcome instead of moving the money again. not_signed_in sent
        // nothing, so its id is kept too. Only a settled refusal
        // (insufficient_balance, invalid_amount, request_id_reused, the
        // server's sign-in codes...) frees the id.
        const retryable = !code || code === 'not_signed_in' || code === 'in_progress' || code === 'server_error';
        return { success: false, retryable, code, error: msg };
    }
};
